import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const ParticleBackground: React.FC = () => {
  const [mouse, setMouse] = useState({ x: 50, y: 28 });

  useEffect(() => {
    const handleMove = (event: MouseEvent) => {
      setMouse({
        x: (event.clientX / window.innerWidth) * 100,
        y: (event.clientY / window.innerHeight) * 100,
      });
    };

    window.addEventListener('mousemove', handleMove);
    return () => window.removeEventListener('mousemove', handleMove);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      <div className="absolute inset-0 bg-cosmic-aurora dark:bg-cosmic-aurora" />
      <div className="absolute inset-0 opacity-60 dark:opacity-100 bg-cosmic-aurora-light dark:bg-cosmic-aurora" />
      <div className="absolute inset-0 grid-pattern opacity-30" />
      <div className="absolute inset-0 noise-overlay" />

      <motion.div
        className="absolute -left-32 top-[-10%] h-[34rem] w-[34rem] rounded-full bg-cosmic-dust blur-3xl"
        animate={{ x: [0, 80, -20, 0], y: [0, 40, 70, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute right-[-12rem] top-[12%] h-[30rem] w-[30rem] rounded-full bg-nebula-cloud blur-3xl"
        animate={{ x: [0, -70, 30, 0], y: [0, 50, -30, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Cursor-following spotlight adds a premium interactive layer without heavy canvas work */}
      <div
        className="absolute inset-0 opacity-70"
        style={{
          background: `radial-gradient(32rem circle at ${mouse.x}% ${mouse.y}%, rgba(110, 231, 249, 0.16), rgba(96, 165, 250, 0.08) 20%, rgba(167, 139, 250, 0.04) 40%, transparent 68%)`,
        }}
      />

      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
    </div>
  );
};

export default ParticleBackground;
